import React, { useCallback, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { isNil } from 'lodash'

import { showErrorNotification } from '../../../core/helpers'

import { useDownloadMenuDocumentMutation } from '../../hooks'
import { menuCurationTaskPropType } from '../../prop-types'

const MenuDocumentDownloadButton = ({ menuCurationTask }) => {
  const { isMenuDocumentDownloading, menuDocumentDownloadError } = useSelector(
    state => state.menuCurationTasks.menuCurationTask,
  )

  const [downloadMenuDocument] = useDownloadMenuDocumentMutation()

  const fileKey = useMemo(
    () => menuCurationTask.menu?.fileKey,
    [menuCurationTask.menu?.fileKey],
  )

  const fileName = useMemo(() => {
    if (!fileKey) {
      return null
    }

    return fileKey.split('/').pop()
  }, [fileKey])

  const handleDownload = useCallback(async () => {
    try {
      const result = await downloadMenuDocument(menuCurationTask.menu.id)
      const downloadUrl = result.data?.downloadMenuDocument?.url

      if (downloadUrl) {
        window.open(downloadUrl, '_blank')
      }
    } catch (error) {
      showErrorNotification({
        title: 'Download failed',
        description: 'Failed to download menu document',
      })
    }
  }, [downloadMenuDocument, menuCurationTask.menu.id])

  useEffect(() => {
    if (menuDocumentDownloadError) {
      showErrorNotification({
        title: 'Download failed',
        description: menuDocumentDownloadError,
      })
    }
  }, [menuDocumentDownloadError])

  if (isNil(fileKey)) {
    return null
  }

  return (
    <Button
      type="link"
      size="small"
      style={{ textWrap: 'auto' }}
      icon={<DownloadOutlined />}
      loading={isMenuDocumentDownloading}
      onClick={handleDownload}
    >
      {fileName}
    </Button>
  )
}

MenuDocumentDownloadButton.propTypes = {
  menuCurationTask: menuCurationTaskPropType.isRequired,
}

export default MenuDocumentDownloadButton
